import React from 'react'
import axios from 'axios';
import { Component } from 'react';
import { baseURL} from '../../../../constants/applicationConstants.js';
import GlobalMainSearchArticlesJsx from './globalMainSearchArticles.jsx'
import { Loader } from '../../../common/loader/loader.jsx';
import { fetchArticleDataFromAPI } from '../../../../shared/helper.js';


export default class GlobalMainSearchArticles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      articleData: null,
      categoryData: null,
      isLoading: false,
      categoryName: "",
      subCategoryData: null,
      categoryId: null,
      subCategoryId: null,
      subCategoryName: null,
      subCategories: [],
      categories: [],
      selectedCategoryNames: [],
      selectAll: false,

      blogData: null,
      isProcessing: true,
      topOffers: null,
      page: 1,
      totalSubCategories: "",
      disableSelectAll: true,
      input: "",
    }
  }

  hitShowAll = (type) => {
    this.setState({ page: 1 });

    if (this.state.categoryName) {
      this.props.history.push({ pathname: "searchArticles", search: `category=${this.state.categoryName}&type=${type}` });

    }
    else {
      this.props.history.push({ pathname: "searchArticles", search: `type=${type}&ddd` });

    }


  }
  getQueryParams() {
    const { location } = this.props;
    const params = new URLSearchParams(location.search);
    return {
      paramName: params.get('search'), // Change 'paramName' to your actual query parameter name
      catName: params.get('category') ?? "", // Change 'paramName' to your actual query parameter name
      typeName: params.get('type') ?? "",
    };
  }


  hitSearch = () => {
    this.setState({ page: 1 });
    const { paramName } = this.getQueryParams();
    if (this.state.input === "") {
      this.setState({ input: paramName });
    }


    const selectedCategoryNamesModified = this.state.selectedCategoryNames.map(name =>
      this.toKebabCase(name)
    );

    const categorySlugString = selectedCategoryNamesModified.join(',');

    // Update state
    this.setState({ categoryName: selectedCategoryNamesModified });

    // Get current query params
    const { typeName } = this.getQueryParams();

    this.props.history.push({
      pathname: "searchArticles",
      search: `category=${categorySlugString}${typeName ? `&type=${typeName}` : ''} &search=${encodeURI(this.state.input)}`
    });
    localStorage.removeItem("selectCategory")
    this.onSubmitButtonClick(this.state.input);

  }

  onSubmitButtonClick = (input) => {
    const token = JSON.parse(localStorage.getItem('token'));

    const { paramName, catName, typeName } = this.getQueryParams();
    const categoryIdFromPev = localStorage.getItem("selectCategory");
    const selectedCategoryNamesModified = this.state.selectedCategoryNames.map(name =>
      this.toKebabCase(name)
    );

    const categorySlugString = selectedCategoryNamesModified.join(',');

    // Update state
    this.setState({ categoryName: selectedCategoryNamesModified });
   

    let catfinal = categoryIdFromPev ? catName || this.state.categoryName : catName || categorySlugString



    this.setState({ isProcessing: true })

    axios.get(`${baseURL}/articles?page=${this.state.page}&type=${typeName}&search=${decodeURI(input) || decodeURI(paramName)}&cat_slug=${catfinal}`,
      {
        headers: { 'x-access-token': token }
      }).then(res => {
        this.setState({ articleData: res.data.data, isProcessing: false });
      }).catch(err => {
        this.setState({ isProcessing: false });
      })
  }

  componentDidMount = () => {
    const { location, history } = this.props;
    const params = new URLSearchParams(location.search);
    const { catName } = this.getQueryParams();

    const isReloaded =
      performance.getEntriesByType("navigation")[0]?.type === "reload";

    if (isReloaded && catName) {
      // Remove category from URL on reload
      params.delete("category");
      history.replace({
        pathname: location.pathname,
        search: params.toString(),
      });
    }

    this.setState({ isLoading: true, categoryName: params.get("category") || "" });

    // First get categories and subcategories
    this.getcategorySubcategory(true);

    // setTimeout(async () => {
    //   this.blogdataCall(catName);
    // }, 2000);
  };

  blogdataCall = async (catSlugs) => {
    this.setState({ isProcessing: true });

    const { paramName, typeName } = this.getQueryParams();
    const fetchedData = await fetchArticleDataFromAPI(catSlugs || "", typeName || "", this.state.page || "", paramName || "", '');
    this.setState({ articleData: fetchedData.data.data, isProcessing: false });

  }

  // componentDidUpdate(prevProps) {
  //   if (prevProps.location !== this.props.location) { // Compare location objects
  //     this.onSubmitButtonClick();
  //   }
  // }

  onPaginationButtonClick = (page) => {
    window.scrollTo(0, 0);
    this.setState({ page: page });
  }


  searchOfferByKeyword = (e) => {
    const data = e.target.value

    this.setState({ input: e.target.value })
    if (data === '') {
      this.setState({ page: 1 })
      this.props.history.push(`/searchArticles`)
      setTimeout(() => {
        this.blogdataCall("");

      }, 500);
      this.selectAllIds()

    }

  }

  getcategorySubcategory = (firstFetch = false) => {
    this.setState({ isLoading: true });
    const token = JSON.parse(localStorage.getItem('token'));

    axios.get(`${baseURL}/institutionCategoriesAndSubCategories`, {
      headers: { 'x-access-token': token }
    }).then(res => {
      const categoryData = res.data.data;

      // Calculate total subcategories directly from fetched data
      const totalSubCategories = categoryData.reduce((acc, category) => {
        return acc + (category.subInstitutionCategories ? category.subInstitutionCategories.length : 0);
      }, 0);

      this.setState({
        categoryData,
        totalSubCategories,
        isLoading: false
      }, () => {
        // This callback ensures categoryData is set before proceeding
        if (firstFetch) {
          const categoryIdFromPrev = localStorage.getItem("selectCategory");
          if (categoryIdFromPrev) {
            this.checkCategoryFromPrevious();
          } else {
            this.selectAllIds();
          }
        }
      });
    }).catch(err => {
      this.setState({ isLoading: false });
      console.error("Error fetching categories:", err);
    });
  };

  checkCategoryFromPrevious = () => {
    const categoryIdsFromPrev = localStorage.getItem("selectCategory");

    if (categoryIdsFromPrev && this.state.categoryData) {
      // Convert "1,2,3" -> [1, 2, 3]
      const categoryIdArray = categoryIdsFromPrev
        .split(',')
        .map(id => parseInt(id.trim()))
        .filter(id => !isNaN(id));

      // Reset states first
      this.setState({ 
        selectAll: false,
        categories: [],
        selectedCategoryNames: [],
        subCategories: []
      });

      // Process each category ID
      categoryIdArray.forEach(categoryId => {
        const selectedCategory = this.state.categoryData.find(
          category => category.institutionCategoryId === categoryId
        );

        if (selectedCategory) {
          this.selectCategoryFromPrevious(selectedCategory);
        }
      });

      // Trigger select all check after all categories are processed
      setTimeout(() => {
        this.triggerSelectAll();
        this.filterCatData();
      }, 50);
    }
  };

  selectCategoryFromPrevious = (selectedCategory) => {
    // Get subcategory IDs for this category
    const institutionCategoryIds = selectedCategory.subInstitutionCategories?.map(
      subCategory => subCategory.institutionCategoryId
    ) || [];

    // Update state to include this category and its subcategories
    this.setState(prevState => ({
      subCategories: [...prevState.subCategories, ...institutionCategoryIds],
      categories: [...prevState.categories, selectedCategory.institutionCategoryId],
      selectedCategoryNames: [...prevState.selectedCategoryNames, selectedCategory.name],
    }));
  };

  selectCategory1 = (selectedCategory) => {
    const institutionCategoryIds = selectedCategory.subInstitutionCategories.map(subCategory => subCategory.institutionCategoryId);

    // Add the category and its subcategories to the state
    this.setState(prevState => ({
      subCategories: [...prevState.subCategories, ...institutionCategoryIds],
      categories: [...prevState.categories, selectedCategory.institutionCategoryId],
      selectedCategoryNames: [...prevState.selectedCategoryNames, selectedCategory.name],
    }));

    // Optionally trigger a filtering or update
    setTimeout(() => {
      this.filterCatData();
    }, 500);
  }

  toKebabCase = (str) => {
    return str
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-') // Replace spaces and special chars with -
      .replace(/^-+|-+$/g, '');    // Trim leading/trailing dashes
  };

  selectAllHit = (e) => {

    const { checked } = e.target;
    if (!checked) {
      this.setState({ selectAll: false });
    } else {
      this.setState({ selectAll: true });
    }

    if (checked) {
      this.setState({ allOffersData: this.state.overallOffers, keyword: "", disableSelectAll: true });

      // Call this to populate state
      this.selectAllIds();



      const allCategoryNames = this.state.categoryData?.map(cat => cat.name) || [];
      const allCategorySlugs = allCategoryNames.map(this.toKebabCase).join(',');

      // ✅ Send all cat slugs to API
      this.blogdataCall(allCategorySlugs);
    }
  }


  onCatgoryClick = (value) => {
    const subData = this.state.categoryData.filter(itm => itm.institutionCategoryId === Number(value))

    this.setState({ subCategoryData: subData[0]?.subInstitutionCategories })
  }



  // filter all selected id
  selectAllIds = () => {

    localStorage.removeItem("selectCategory")
    const institutionCategoryIds = this.state.categoryData?.map(category => category.institutionCategoryId);
    const institutionCategoryNames = this.state.categoryData?.map(category => category.name);

    this.setState({ categories: institutionCategoryIds })
    this.setState({ selectedCategoryNames: institutionCategoryNames })


    // Extract sub-institution category IDs as well
    this.state.categoryData?.forEach(category => {
      if (category?.subInstitutionCategories) {
        const subIds = category?.subInstitutionCategories?.map(subCategory => subCategory.institutionCategoryId);
        // institutionCategoryIds.push(...subIds);
        this.setState(prevState => ({
          subCategories: [...prevState.subCategories, ...subIds] // Spread existing items and add new items
        }));
        // this.setState({ subCategories: ...subIds })

      }
    });

    this.setState({ institutionCategoryIds },() => {
      this.blogdataCall(null);
    });
  }




  filterCatData = () => {
    const categoryIdFromPev = localStorage.getItem("selectCategory");
    const selectedCategoryNamesModified = this.state.selectedCategoryNames.map(name =>
      this.toKebabCase(name)
    );

    const categorySlugString = selectedCategoryNamesModified.join(',');

    // Update state
    this.setState({ categoryName: selectedCategoryNamesModified });

    // Get current query params
    const { typeName, paramName } = this.getQueryParams();

    // Update the URL with new slug
    this.props.history.push({
      pathname: "searchArticles",
      search: categoryIdFromPev ? `category=${categorySlugString}${typeName ? `&type=${typeName}` : ''}${paramName ? `&search=${paramName}` : ''}` : `${typeName ? `&type=${typeName}` : ''}${paramName ? `&search=${paramName}` : ''}`
    });

    // Fetch filtered blog data
    this.blogdataCall(selectedCategoryNamesModified);

    // If no subcategories selected, fallback to all
    if (this.state.subCategories.length === 0) {
      this.blogdataCall("");
      this.setState({ selectAll: true });
      this.selectAllIds();
    }
  };










  selectCategory = (data, e) => {
    localStorage.removeItem("selectCategory")
    localStorage.setItem("changing", true)

    const { checked } = e.target


    this.setState({ selectAll: false, disableSelectAll: false })

    this.triggerSelectAll()        // 
    const selectedId = data.institutionCategoryId;
    this.setState({ selectedCategoryId: selectedId });

    const selectedCategory = this.state.categoryData.find(category => category.institutionCategoryId === selectedId);


    if (selectedCategory) {
      const insInsideCat = selectedCategory.subInstitutionCategories
      const institutionCategoryIds = insInsideCat.map(category => category.institutionCategoryId);


      if (checked) {
        this.setState((prevState) => ({
          subCategories: [...prevState.subCategories, ...institutionCategoryIds],
        }));
        this.setState({ page: 1 })


      } else {

        this.setState((prevState) => ({
          subCategories: prevState.subCategories.filter(
            (id) => !institutionCategoryIds.includes(id) // Remove IDs present in newIds
          )
        }));
        this.setState({ page: 1 })
      }
    } else {
      this.setState({ subCategories: [] });
    }
    setTimeout(() => {
      this.filterCatData()

    }, 500);


    this.setState((prevState) => {
      const { categories } = prevState;

      // Check if the id is already in the categories
      if (categories.includes(data.institutionCategoryId)) {
        // Remove the id
        return { categories: categories.filter(selectedId => selectedId !== data.institutionCategoryId) };
      } else {
        // Add the id
        return { categories: [...categories, data.institutionCategoryId] };
      }
    });
    this.setState((prevState) => {
      const { selectedCategoryNames } = prevState;

      // Check if the id is already in the selectedCategoryNames
      if (selectedCategoryNames.includes(data.name)) {
        // Remove the id
        return { selectedCategoryNames: selectedCategoryNames.filter(selectedId => selectedId !== data.name) };
      } else {
        // Add the id
        return { selectedCategoryNames: [...selectedCategoryNames, data.name] };
      }
    });
  }


  handleCheckboxChange = (id) => (event) => {
    if (event.target.checked) {
      // Add ID to the selected array if not already present
      this.setState((prevState) => ({
        selectedIds: prevState.selectedIds.includes(id)
          ? prevState.selectedIds
          : [...prevState.selectedIds, id]
      }));
    } else {
      // Remove ID from the selected array when unchecked
      this.setState((prevState) => ({
        selectedIds: prevState.selectedIds.filter((selectedId) => selectedId !== id)
      }));
    }
  };















  triggerSelectAll = () => {
    setTimeout(() => {
      const uniqueSubCatIds = new Set(this.state.subCategories);
      const uniqueCount = uniqueSubCatIds.size;
      const totalSubCount = this.state.totalSubCategories;

      if (uniqueCount === totalSubCount) {
        this.setState({ selectAll: true, disableSelectAll: true });
      } else {
        this.setState({ selectAll: false, disableSelectAll: false });
      }
    }, 500);
  };

  selectSubCategory = (data) => {
    localStorage.removeItem("selectCategory")
    localStorage.setItem("changing", true)
    this.setState({ selectAll: false, disableSelectAll: false })

    this.triggerSelectAll()
    this.setState((prevState) => {
      if (prevState.subCategories.includes(data.institutionCategoryId)) {
        // If the ID is already selected, remove it
        return { subCategories: prevState.subCategories.filter((prevId) => prevId !== data.institutionCategoryId) };
      } else {
        // If the ID is not selected, add it
        return { subCategories: [...prevState.subCategories, data.institutionCategoryId] };
      }
    });

    setTimeout(() => {
      this.filterSubData()

    }, 500);

    // console.warn("selected sub cat", data,this.state.checkedCats)

  }

  filterSubData = () => {
    // Add implementation for filterSubData if needed
    this.filterCatData();
  }

  onCategoryClickMob = (catId, catName) => {
    this.setState({ isProcessing: true })

    this.props.history.replace('/')
    this.props.history.push(`/articles?category=${catName}`)
    this.setState({ categoryId: catId, categoryName: catName });
    const type = 'featured,main_news,glossory,trending'

    setTimeout(async () => {
      const fetchedData = await fetchArticleDataFromAPI(this.state.categoryName || "", type || "", this.state.page || "", "");

      this.setState({ articleData: fetchedData.data.data, isProcessing: false });

    }, 400);
    // this.setState({
    //     subCategoryData: this.state.categoryData.filter(catDT => catDT.name === catName)[0]?.subInstitutionCategories
    // }, () => this.isFromSubmissionBlock())

  }


  render() {
    return (
      <div>
        <GlobalMainSearchArticlesJsx
          articleData={this.state.articleData}
          onSubmitButtonClick={this.onSubmitButtonClick}
          onPaginationButtonClick={this.onPaginationButtonClick}
          searchOfferByKeyword={this.searchOfferByKeyword}
          hitSearch={this.hitSearch}
          input={this.state.input}
          page={this.state.page} subCategories={this.state.subCategories}
          categories={this.state.categories}
          categoryData={this.state.categoryData}

          onCategoryClick={this.onCategoryClick}
          categoryName={this.state.categoryName}
          selectAllHit={this.selectAllHit}
          subCategoryData={this.state.subCategoryData}
          closFunction={this.closeFunction}
          selectCategory={this.selectCategory}
          selectSubCategory={this.selectSubCategory}
          selectAll={this.state.selectAll}
          hitShowAll={this.hitShowAll}
          disableSelectAll={this.state.disableSelectAll}
          onCategoryClickMob={this.onCategoryClickMob}

        />

        {this.state.isProcessing && <Loader />}
      </div>
    )
  }
}